import { icons } from "../../../statics/icons";

export enum ROLES {
  PROVIDER = "PROVIDER",
  DEPLOYER = "DEPLOYER",
  IMPORTER = "IMPORTER",
  DISTRIBUTER = "DISTRIBUTER",
  AUTHORISED_REPRESENTATIVE = "AUTHORISED_REPRESENTATIVE",
  DATA_SUBJECT = "DATA_SUBJECT",
}

export enum CASES_PAGE_TYPES {
  PUBLISHED = "PUBLISHED",
  DEVELPMENT = "DEVELOPMENT",
  DEMAND = "DEMAND",
  PRODUCTS = "PRODUCTS",
  UN_PUBLISHED = "UN_PUBLISHED",
  INVENTORY = "INVENTORY",
  USER = "USER",
}

export interface AIRole {
  id: string;
  title: string;
  subTitle: string;
  name: ROLES;
  icon: string;
  activeIcon: string;
  key: ROLES;
  disabled?: boolean;
  role?: CASES_PAGE_TYPES;
}

interface AIRoleKeys {
  DEVELOPER: AIRole;
  DISTRIBUTER: AIRole;
  IMPORTER: AIRole;
  USER: AIRole;
}

export const AIRolesByKey: any = {
  DEVELOPER: {
    title: "USECASE_CREATE.AI_DEVELOPER",
    subTitle: "USECASE_CREATE.DEVELOPER_OF_THE_AI_PRODUCT",
    name: ROLES.PROVIDER,
    icon: icons.AIDeveloperPrimary,
    activeIcon: icons.AIDeveloperWhite,
    key: ROLES.PROVIDER,
  },
  DISTRIBUTER: {
    title: "USECASE_CREATE.AI_DISTRIBUTER",
    subTitle: "USECASE_CREATE.DISTRIBUTES_AN_AI_PRODUCT",
    name: ROLES.DISTRIBUTER,
    icon: icons.AIDistributorPrimary,
    activeIcon: icons.AIDistributorWhite,
    key: ROLES.DISTRIBUTER,
  },
  IMPORTER: {
    title: "USECASE_CREATE.AI_IMPORTER",
    subTitle: "USECASE_CREATE.IMPORTER_AI_PRODUCT",
    name: ROLES.IMPORTER,
    icon: icons.AIImporterPrimary,
    activeIcon: icons.AIImporterWhite,
    key: ROLES.IMPORTER,
  },
  USER: {
    title: "USECASE_CREATE.AI_USER",
    subTitle: "USECASE_CREATE.COMPANIES_USING_AN_AI_PRODUCT",
    name: ROLES.AUTHORISED_REPRESENTATIVE,
    icon: icons.AIUserPrimary,
    activeIcon: icons.AIUserWhite,
    key: ROLES.AUTHORISED_REPRESENTATIVE,
  },
};

export const AIRolesList: AIRole[] = [
  {
    id: ROLES.PROVIDER,
    title: "USECASE_CREATE.AI_DEVELOPER",
    subTitle: "USECASE_CREATE.DEVELOPER_OF_THE_AI_PRODUCT",
    name: ROLES.PROVIDER,
    icon: icons.AIDeveloperPrimary,
    activeIcon: icons.AIDeveloperWhite,
    key: ROLES.PROVIDER,
    role: CASES_PAGE_TYPES.PRODUCTS,
  },
  {
    id: ROLES.DISTRIBUTER,
    title: "USECASE_CREATE.AI_DISTRIBUTER",
    subTitle: "USECASE_CREATE.DISTRIBUTES_AN_AI_PRODUCT",
    name: ROLES.DISTRIBUTER,
    icon: icons.AIDistributorPrimary,
    activeIcon: icons.AIDistributorWhite,
    key: ROLES.DISTRIBUTER,
    role: CASES_PAGE_TYPES.INVENTORY,
  },
  {
    id: ROLES.IMPORTER,
    title: "USECASE_CREATE.AI_IMPORTER",
    subTitle: "USECASE_CREATE.IMPORTER_AI_PRODUCT",
    name: ROLES.IMPORTER,
    icon: icons.AIImporterPrimary,
    activeIcon: icons.AIImporterWhite,
    key: ROLES.IMPORTER,
    role: CASES_PAGE_TYPES.INVENTORY,
  },
  {
    id: ROLES.AUTHORISED_REPRESENTATIVE,
    title: "USECASE_CREATE.AI_USER",
    subTitle: "USECASE_CREATE.COMPANIES_USING_AN_AI_PRODUCT",
    name: ROLES.AUTHORISED_REPRESENTATIVE,
    icon: icons.AIUserPrimary,
    activeIcon: icons.AIUserWhite,
    key: ROLES.AUTHORISED_REPRESENTATIVE,
    role: CASES_PAGE_TYPES.USER,
  },
];
